import { Row } from "./Flexbox";
import Text from "./Text";
import {useState} from "react";

const MaterialsRow = props => {
    const [hover, setHover] = useState(false);
    const [selected, setSelected] = useState(false);

    const textColor = hover ? props.theme.ONED : props.theme.SEVENB;

    const isSelectable = props.data._details && props.data._details.length > 1;    //Same month-filtered details the row shows

    const handleClick = () => {
        if(isSelectable) {
            setSelected(!selected);
        }
    }

    if(!props.selectedMonths || props.selectedMonths.length === 0) {    //Don't show anything if there are no months selected
        return null;
    }

    if (props.data._parts === '') {
        return null;
    }

    const formattedForecast = parseFloat(props.data._forecast).toLocaleString('es-MX', {minimumFractionDigits: 3, maximumFractionDigits: 3});
    const filteredDetails = props.data._details;

    return (
        <>
            <Row
                onClick={handleClick}
                onMouseEnter={() => {setHover(true);}} 
                onMouseLeave={() => {setHover(false);}}
                style={{
                    borderRadius: 4,
                    width: '100%',
                    ...props.style,
                    paddingTop: 4, 
                    paddingBottom: 4,
                }}
            >
                <Text style={{width: 120, height: 20, color: selected ? props.theme.Magenta : textColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}} size={15}>{props.data.codItem ? props.data.codItem : "-"}</Text>
                <div style={{width: 319, maxHeight: 20, overflow: 'hidden', whiteSpace: 'nowrap' , textOverflow: 'ellipsis'}} title={props.data.material}><Text style={{width: 319, height: 20, color: selected ? props.theme.Magenta : textColor}} size={15}>{props.data.material}</Text></div>
                <Text style={{width: 120, height: 20, color: selected ? props.theme.Magenta : textColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}} size={15}>{props.data._customers}</Text>
                <Text style={{width: 181, height: 20, color: selected ? props.theme.Magenta : textColor}} size={15}>{props.data._parts}</Text>
                <Text style={{width: 120, height: 20, color: selected ? props.theme.Magenta : textColor, textAlign: 'right'}} size={15}>{formattedForecast}</Text>
                <Text style={{width: 69, height: 20, color: selected ? props.theme.Magenta : textColor, textAlign: 'right'}} size={15}>{props.data.unidad}</Text>                
            </Row>
            {/* Breakdown */}
            {selected && isSelectable && props.data.detalles.length > 0 && (    
                <div style={{width: '100%'}}>
                    {filteredDetails.map((item) => (     //Filter the results according to the selected months
                        <Row key={item.id} style={{width: '100%', height: 28, justifyContent: 'space-between', backgroundColor: 'rgba(230, 1, 126, .07)', paddingTop: 4, paddingBottom: 4}} >
                            <div style={{width: 120, maxHeight: 20, overflow: 'hidden', whiteSpace: 'nowrap' , textOverflow: 'ellipsis'}} title={item.codItem}><Text style={{ width: 120, height: 20, color: props.theme.ONED, overflow: 'hidden', whiteSpace: 'nowrap' , textOverflow: 'ellipsis' }} size={15}>{item.codItem || "-"}</Text></div>
                            <div style={{width: 319, maxHeight: 20, overflow: 'hidden', whiteSpace: 'nowrap' , textOverflow: 'ellipsis'}} title={item.material}><Text style={{ width: 319, height: 20, color: props.theme.ONED}} size={15}>{item.material}</Text></div>
                            <Text style={{ width: 120, height: 20, color: props.theme.ONED, overflow: 'hidden',whiteSpace: 'nowrap' , textOverflow: 'ellipsis'}} size={15}>{item.cliente}</Text>
                            <Text style={{ width: 181, height: 20, color: props.theme.ONED }} size={15}>{item.noParte}</Text>
                            <Text style={{ width: 120, height: 20, color: props.theme.ONED, textAlign: 'right' }} size={15}>{parseFloat(item.forecast).toLocaleString('es-MX', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</Text>                            <Text style={{ width: 69, height: 20, color: props.theme.ONED, textAlign: 'right' }} size={15}>{item.unidad}</Text>
                        </Row>
                    ))}
                </div>
            )}
        </>
        
    );
};
export default MaterialsRow;